import { type TablePaginationProps } from "@mui/material";

/** @deprecated We are phasing out `cc-ui` */
export const tablePaginationProps: Pick<TablePaginationProps, "slotProps"> = {
  slotProps: {
    actions: {
      firstButton: { "aria-label": "first page", size: "small" },
      lastButton: { "aria-label": "last page", size: "small" },
      nextButton: { "aria-label": "next page", size: "small" },
      previousButton: { "aria-label": "previous page", size: "small" },
    },
  },
};
